import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout } from './features/authSlice';
import { useTokenExpiration } from './hooks/useTokenExpiration';
import { useActivityTokenRefresh } from './hooks/useActivityTokenRefresh';

import ToastProvider from './context/ToastProvider';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import VersionUpdateDialog from './components/VersionUpdateDialog';

const App = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);

  // Monitor token expiration
  useTokenExpiration();
  
  // Refresh token based on mouse activity
  useActivityTokenRefresh();

  useEffect(() => {
    const tokenFromStorage = localStorage.getItem('token');
    if (tokenFromStorage) {
      dispatch(login(tokenFromStorage));
    } else {
      dispatch(logout());
    }
  }, [dispatch]);

  return (
    <Router>
     
        <ToastProvider>
          <VersionUpdateDialog />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Login />} />
          </Routes>
        </ToastProvider>
      
    </Router>
  );
};

export default App;
